import moment from 'moment';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import { COMMON_DATE_FORMATTER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

// line-x轴label格式化
export function xAxisLabelFormatter(value: string): string {
  return moment(value).format(COMMON_DATE_FORMATTER);
}

// y轴label格式化
export function yAxisLabelFormatter(payload: number): string {
  const valueTemp = payload < 10 ? payload : mathFormat(payload, true);
  return `${valueTemp}`;
}
